module.exports = __webpack_public_path__ + "static/media/trainVideo9.40b79715.mp4";